module.exports = {"ADM_INSPECT_ACCOUNTS_SEEING_AS":"Lihat sebagai","ADM_INSPECT_ACCOUNTS_BACK_TO_ADMIN":"Kembali ke Admin"}